<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Orders</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <!-- Email -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <md-input type="text" placeholder="Email" v-model="email"></md-input>
              </md-field>
            </div>

            <!-- Device Purchase Status -->
            <div class="md-layout-item md-size-50">
              <md-field>
                <label>Order Status</label>
                <md-select v-model="orderStatus">
                  <md-option value="">All</md-option>
                  <md-option value="Confirmed">Confirmed</md-option>
                  <md-option value="Shipped">Shipped</md-option>
                  <md-option value="Out For Delivery">Out For Delivery</md-option>
                  <md-option value="Delivered">Delivered</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-button class="md-primary" :disabled="isDisabled" @click="orderList()">Search</md-button>
            </div>
          </div>

          <hr>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Per page</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Order Number" md-sort-by="orderNumber">
                    <a href="javascript:void(0)" @click="$router.push({ path: 'order-detail', query: { id: item._id }})">{{ item.orderNumber }}</a>
                    <span v-if="item.subscriptionType == 'subscription_cycle'"><br> <b>{{ item.subscriptionType  }}</b></span>
                </md-table-cell>
                <md-table-cell md-label="Method" md-sort-by="Total">
                  <small><b>Total:</b> £{{ item.orderTotal }}</small><br>
                  <small><b>Discount:</b> £{{ item.discountAmount }}</small><br>
                  <small><b>Payable Amount:</b> £{{ item.payableAmount }}</small>
                </md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="email">
                  {{ item.name }}<br>
                  {{ item.email }}
                </md-table-cell>
                <md-table-cell md-label="Order Status" md-sort-by="status">
                    <span :class="statusClass(item.orderStatus)">
                    {{ item.orderStatus }}
                    </span>
                </md-table-cell>
                <md-table-cell md-label="Review Count">{{ item.reviewRequestSentCount }}
                  &nbsp;&nbsp;
                <button class="tag-btn-inside" :style="{'right':'unset', top: '30%'}" 
                @click="$router.push({ path: '/kid/review-request', query: { email: item.email, orderNumber: item.orderNumber }})">Request Review</button>
                </md-table-cell>
                <md-table-cell md-label="Created" md-sort-by="created_at">{{ HumanReadableDateFormat(item.created_at) }}</md-table-cell>
                <md-table-cell md-label="Actions">
                    <md-button class="md-just-icon md-info md-simple" v-if="item.subscriptionType != 'subscription_cycle'" @click="$router.push({ path: 'order-detail', query: { id: item._id }})">
                        <md-icon>visibility</md-icon>
                    </md-button>
                </md-table-cell>
            </md-table-row>

          </md-table>
          
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Swal from "sweetalert2";
import OrdersDataService from "../../services/SuperAdmin/Kids/OrdersDataService";

export default {
  components: {
    Pagination,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      currentSort: "orderId",
      currentSortOrder: "asc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableData: [],
      searchedData: [],
      email:"",
      orderStatus:""
    };
  },
  methods: {
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },
    statusClass(status) {
        switch (status) {
            case "Confirmed":
                return "badge badge-success";
            case "Shipped":
                return "badge badge-primary";
            case "Out For Delivery":
                return "badge badge-warning";
            case "Delivered":
                return "badge badge-info";
            default:
                return "";
        }
    },
    orderList() {
        let data = { 
          subscriptionType: this.$route.path == '/kid/subscriptions' ? 'subscription_cycle' : 'subscription_create', 
          email: this.email, orderStatus: this.orderStatus };
        OrdersDataService.orderList(data)
          .then((response) => {
            this.tableData = response.data.data;
          })
          .catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
          });
    },
  },
  watch: {
    '$route.path'(newPath) {
      this.orderList(); // ← just call your existing method
    }
  },
  beforeMount() {
    this.orderList();
  },
  mounted() {
  },
};
</script>

<style scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: top;
}

::v-deep .md-table-cell[md-label="Email"],
::v-deep .md-table-cell[md-label="Order Status"] {
  min-width: 160px;
}
.tag-btn-inside {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.tag-btn-inside:hover {
  background: #6a1b9a;
}

</style>
